import { z } from 'zod'

import {
	TRAINING_AUDIENCE_OPTIONS,
	TRAINING_DELIVERY_OPTIONS,
	TRAINING_FREQUENCY_OPTIONS,
} from '#app/routes/mocra+/_form+/intake-options.ts'

export const TrainingProgramSchema = z.object({
	audience: z.enum(
		TRAINING_AUDIENCE_OPTIONS.map((option) => option.value) as [
			(typeof TRAINING_AUDIENCE_OPTIONS)[number]['value'],
			...string[],
		],
	),
	delivery: z.enum(
		TRAINING_DELIVERY_OPTIONS.map((option) => option.value) as [
			(typeof TRAINING_DELIVERY_OPTIONS)[number]['value'],
			...string[],
		],
	),
	cadence: z.enum(
		TRAINING_FREQUENCY_OPTIONS.map((option) => option.value) as [
			(typeof TRAINING_FREQUENCY_OPTIONS)[number]['value'],
			...string[],
		],
	),
	platform: z
		.string({
			required_error: 'Name the platform or tool used.',
		})
		.min(1, 'Name the platform or tool used.'),
	tracksCompletion: z.coerce.boolean().default(true),
})

export type TrainingProgramEntry = z.infer<typeof TrainingProgramSchema>
